const BetOfferYesNo = {
  title: 'Example JSON',
  expectedOutput: 'Full Time: Feyenoord Outcome Participant',
  initialDisplayedCode: `{
  "outcomeId": 2950948554,
  "betOffer": {
    "id": 2365741549, 
    "betOfferType": {
      "id": 18, `,
  moreCode: `
      "name": "Yes/No"
    },
    "criterion": {
        "label": "Full Time"
    },
    "outcomes": [
        {
            "id": 2950948551,
            "participant": "Arsenal Outcome Participant"
        },{
            "id": 2950948554,
            "participant": "Feyenoord Outcome Participant"
        }
    ]
    },
    "event": {
       "id": 1019865964,
       "tags": ["MATCH"]
     }
}`,
};

export default BetOfferYesNo;
